import React from 'react'
import Accordion from 'react-bootstrap/Accordion'

const Packages = () => {
  return (
    <div id='packages' className='content'>
      <Accordion>
        <Accordion.Item eventKey="0">
          <Accordion.Header><span><b>Professional Wash</b><br />£45 - 1½ Hours</span></Accordion.Header>
          <Accordion.Body>
            <ul>
              <li>Pre-wash (Traffic Film Remover) used on car and wheels</li>
              <li>Jet Wash to remove Pre-wash</li>
              <li>Two Bucket Hand Wash with Microfibre mits and Grit Guards including door and boot shuts</li>
              <li>Jet Wash to remove Two Bucket Wash</li>
              <li>Bodywork dried using microfibre drying towel</li>
              <li>Paint protection applied</li>
              <li>Tyres dressed to give new tyre look</li>
            </ul>
          </Accordion.Body>
        </Accordion.Item>
        <Accordion.Item eventKey="1">
          <Accordion.Header><span><b>Mini Valet (Small vehicle)</b><br />£50 - 3 Hours</span></Accordion.Header>
          <Accordion.Body>
            <b><i>Small vehicle examples - Mini, Fiat 500, Smart car etc.</i></b>
            <br></br>
            <p>This package includes every service in the Professional Wash package, additional services are indicated with a +.</p>
            <ul>
              <li>Pre-wash (Traffic Film Remover) used on car and wheels</li>
              <li>Jet Wash to remove Pre-wash</li>
              <li>Two Bucket Hand Wash with Microfibre mits and Grit Guards including door and boot shuts</li>
              <li>Jet Wash to remove Two Bucket Wash</li>
              <li>Bodywork dried using microfibre drying towel</li>
              <li>Paint protection applied</li>
              <li>Tyres dressed to give new tyre look</li>
              <ul>+ Vacuum Carpets and Mats</ul>
              <ul>+ Vacuum Seats and Boot</ul>
              <ul>+ Windows cleaned</ul>
              <ul>+ New Car Scent applied (optional)</ul>
            </ul>
          </Accordion.Body>
        </Accordion.Item>
        <Accordion.Item eventKey="2">
          <Accordion.Header><span><b>Mini Valet (Medium vehicle)</b><br />£60 - 3 Hours</span></Accordion.Header>
          <Accordion.Body>
            <b><i>Medium vehicle examples - BMW 1/2/3 series, VW Golf, Ford Focus etc.</i></b>
            <p>This package includes every service in the Professional Wash package, additional services are indicated with a +.</p>
            <ul>
              <li>Pre-wash (Traffic Film Remover) used on car and wheels</li>
              <li>Jet Wash to remove Pre-wash</li>
              <li>Two Bucket Hand Wash with Microfibre mits and Grit Guards including door and boot shuts</li>
              <li>Jet Wash to remove Two Bucket Wash</li>
              <li>Bodywork dried using microfibre drying towel</li>
              <li>Paint protection applied</li>
              <li>Tyres dressed to give new tyre look</li>
              <ul>+ Vacuum Carpets and Mats</ul>
              <ul>+ Vacuum Seats and Boot</ul>
              <ul>+ Windows cleaned</ul>
              <ul>+ New Car Scent applied (optional)</ul>
            </ul>
          </Accordion.Body>
        </Accordion.Item>
        <Accordion.Item eventKey="3">
          <Accordion.Header><span><b>Mini Valet (Large vehicle)</b><br />£70 - 3/4 Hours</span></Accordion.Header>
          <Accordion.Body>
            <b><i>Large vehicle examples - BMW 4/5/6+ series, SUV & 4x4 etc.</i></b>
            <p>This package includes every service in the Professional Wash package, additional services are indicated with a +.</p>
            <ul>
              <li>Pre-wash (Traffic Film Remover) used on car and wheels</li>
              <li>Jet Wash to remove Pre-wash</li>
              <li>Two Bucket Hand Wash with Microfibre mits and Grit Guards including door and boot shuts</li>
              <li>Jet Wash to remove Two Bucket Wash</li>
              <li>Bodywork dried using microfibre drying towel</li>
              <li>Paint protection applied</li>
              <li>Tyres dressed to give new tyre look</li>
              <ul>+ Vacuum Carpets and Mats</ul>
              <ul>+ Vacuum Seats and Boot</ul>
              <ul>+ Windows cleaned</ul>
              <ul>+ New Car Scent applied (optional)</ul>
            </ul>
          </Accordion.Body>
        </Accordion.Item>
        <Accordion.Item eventKey="4">
          <Accordion.Header><span><b>Premium Valet</b><br />£180 - 5 Hours</span></Accordion.Header>
          <Accordion.Body>
            <p>This package includes every service in the Professional Wash & Mini Valet packages, additional services are indicated with a +.</p>
            <ul>
              <li>Pre-wash (Traffic Film Remover) used on car and wheels</li>
              <li>Jet Wash to remove Pre-wash</li>
              <li>Two Bucket Hand Wash with Microfibre mits and Grit Guards including door and boot shuts</li>
              <li>Jet Wash to remove Two Bucket Wash</li>
              <li>Bodywork dried using microfibre drying towel</li>
              <li>Paint protection applied</li>
              <li>Tyres dressed to give new tyre look</li>
              <li>Vacuum Carpets and Mats</li>
              <li>Vacuum Seats and Boot</li>
              <li>Windows cleaned</li>
              <li>New Car Scent applied (optional)</li>
              <ul>+ Wheel treatment to remove break dust, iron particles etc</ul>
              <ul>+ Wheels hand washed</ul>
              <ul>+ Hot Air Blower Dry for windows, mirrors, wheels, trims & badges</ul>
              <ul>+ Wheels waxed </ul>
              <ul>+ Exterior trims treated with colour enhancer</ul>
              <ul>+ Arches cleaned and dressed</ul>
              <ul>+ Window protection applied</ul>
              <ul>+ Steam clean seats and carpets</ul>
              <ul>+ Condition leather on seats and trims</ul>
              <ul>+ Window protection applied</ul>
              <ul>+ Dress dashboard, centre console and door panels </ul>
            </ul>
          </Accordion.Body>
        </Accordion.Item>
        <Accordion.Item eventKey="5">
          <Accordion.Header><span><b>Exterior Ultimate Valet</b><br />£450 - 3/4 Days</span></Accordion.Header>
          <Accordion.Body>
            <p>This intensive exterior package removes swirls, light scratches and blemishes.</p>
            <ul>
              <li>Pre-wash (Traffic Film Remover) used on car and wheels</li>
              <li>Jet Wash to remove Pre-wash</li>
              <li>Two Bucket Hand Wash with Microfibre mits and Grit Guards including door and boot shuts</li>
              <li>Jet Wash to remove Two Bucket Wash</li>
              <li>Bodywork dried using microfibre drying towel</li>
              <li>Tyres dressed to give new tyre look</li>
              <li>Wheel treatment to remove break dust, iron particles etc</li>
              <li>Wheels hand washed</li>
              <li>Hot Air Blower Dry for windows, mirrors, wheels, trims & badges</li>
              <ul>+ Clay Bar to remove remaining paint contamination</ul>
              <ul>+ Compound paintwork to remove shallow scratches/swirl marks</ul>
              <ul>+ Machine Polish to smooth out paintwork and correct imperfections</ul>
            </ul>
          </Accordion.Body>
        </Accordion.Item>
        <Accordion.Item eventKey="4">
          <Accordion.Header><span><b>Exterior Ultimate Valet + Ceramic Coating</b><br />£550 - 4/5 Days</span></Accordion.Header>
          <Accordion.Body>
            <p>This intensive exterior package removes swirls, light scratches and blemishes. Plus long lasting ceramic coating (8/10 years).</p>
            <ul>
              <li>Pre-wash (Traffic Film Remover) used on car and wheels</li>
              <li>Jet Wash to remove Pre-wash</li>
              <li>Two Bucket Hand Wash with Microfibre mits and Grit Guards including door and boot shuts</li>
              <li>Jet Wash to remove Two Bucket Wash</li>
              <li>Bodywork dried using microfibre drying towel</li>
              <li>Tyres dressed to give new tyre look</li>
              <li>Wheel treatment to remove break dust, iron particles etc</li>
              <li>Wheels hand washed</li>
              <li>Hot Air Blower Dry for windows, mirrors, wheels, trims & badges</li>
              <li>Clay Bar to remove remaining paint contamination</li>
              <li>Compound paintwork to remove shallow scratches/swirl marks</li>
              <li>Machine Polish to smooth out paintwork and correct imperfections</li>
              <ul>+ Ceramic Coating</ul>
            </ul>
          </Accordion.Body>
        </Accordion.Item>
        <Accordion.Item eventKey="6">
          <Accordion.Header><span><b>Additional Services</b><br />Price will vary dependant on condition</span></Accordion.Header>
          <Accordion.Body>
            <ul>
              <li>Headlight Lenses Refurbed - £30</li>
              <li>Engine Bay Cleaned and Treated - £30</li>
              <li>Soft-top Clean and Conditioned</li>
              <li>Small scratches can be removed using compound - £15/Hour</li>
              <li>Maintenance valet - £95. Required if car condition is very poor and requires a preliminary valet to bring the vehicle to an acceptable state for above valeting packages</li>
            </ul>
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>
      <p className='disclaimer'>*Prices may vary due to size and condition of vehicle</p>
    </div >
  )
}

export default Packages